<ng-container *ngIf="!string_filter && baseDatasourceProductExclusive.isTableLoaded && baseDatasourceProductExclusive.totalItem$.getValue() === 0; else elseBlock" cardBody>
  <app-card-empty icon="{{ iconNone }}" text="Distributor belum memiliki Produk Ekslusif.">
    <button *ngIf="ShowAddProductExclusive" (click)="handleGoTo()" class="btn btn-outline btn-outline-disabled mt-5" type="button">
      <span class="text-primary">Tambah Produk Ekslusif</span>
    </button>

    <button *ngIf="IsHaveProductExclusive" (click)="handleHistory()" class="btn btn-outline btn-outline-disabled mt-5" type="button">
      <span class="text-primary">Lihat Histori</span>
    </button>
  </app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <ng-container cardHeader>
      <app-input-search
        (actionFilter)="onSearch($event)"
        [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject"
        [placeholder]="'Cari Nama Varian Produk'"
        [value]="string_filter"
      ></app-input-search>
      <app-skeleton-text [isLoading]="isLoading" [count]="1" [type]="'btn'">
        <button (click)="handleGoTo()" *ngIf="ctaPrivilege.value.add" class="btn btn-outline btn-outline-disabled mx-4">
          <span [inlineSVG]="ASSET_ICON.IC_PLUS" class="img-fluid"></span>
          <span class="text-primary">&nbsp; Tambah Produk Ekslusif</span>
        </button>
        <button (click)="handleHistory()" *ngIf="ctaPrivilege.value.history" class="btn btn-outline btn-outline-disabled">
          <span [inlineSVG]="ASSET_ICON.IC_CLOCK" class="img-fluid"></span>
          <span class="text-primary">&nbsp; Histori</span>
        </button>
      </app-skeleton-text>
    </ng-container>

    <ng-container cardBody>
      <ng-container
        *ngIf="string_filter && baseDatasourceProductExclusive.isTableLoaded && baseDatasourceProductExclusive.totalItem$.getValue() === 0; else elseFilterBlock"
        cardBody
      >
        <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data Produk Ekslusif."></app-card-empty>
      </ng-container>
      <ng-template #elseFilterBlock>
        <div class="table-responsive">
          <table [dataSource]="baseDatasourceProductExclusive" class="table w-100 gy-5 table-row-bordered align-middle" mat-table matSort>
            <ng-container *ngFor="let tableColumn of tableColumns; index as i" [matColumnDef]="tableColumn.key">
              <ng-container *ngIf="tableColumn.isSortable; else notSortTable">
                <th
                  *matHeaderCellDef
                  [arrowPosition]="'after'"
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [mat-sort-header]="tableColumn.key"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                    <app-table-content [width]="70"></app-table-content>
                  </div>
                </th>
              </ng-container>
              <ng-template #notSortTable>
                <th
                  *matHeaderCellDef
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [ngClass]="{
                    'min-w-70px text-center': tableColumn.key === 'actions',
                    'w-250px': tableColumn.key === 'alamat'
                  }"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="tableColumn.key === 'available_stock'" class="d-flex info-header-detail-products">
                    <div *ngIf="baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                      {{ tableColumn.title }}
                    </div>
                    <div *ngIf="!baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                      <app-table-content [width]="180"></app-table-content>
                    </div>
                    <span
                      *ngIf="baseDatasourceProductExclusive.isFinishLoadingSubject.value"
                      [inlineSVG]="ASSET_ICON.IC_INFO"
                      class="ms-2 cursor-pointer"
                      ngbPopover="Jumlah stok yang tersedia untuk diorder"
                      placement="bottom"
                      popoverClass="tooltip-info-product text-primary"
                    ></span>
                  </div>
                  <div *ngIf="baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceProductExclusive.isFinishLoadingSubject.value">
                    <app-table-content [width]="180"></app-table-content>
                  </div>
                </th>
              </ng-template>
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'actions'" class="text-center">
                    <button
                      [ngClass]="{
                        'is-download': element['is_download']
                      }"
                      class="btn btn-table-actions-download"
                    >
                      <app-table-content [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject" [type]="'icon'">
                        <span class="mx-3" (click)="handleAction(element)" [inlineSVG]="ASSET_ICON.IC_ACTIONS_TABLE"></span>
                        <span *ngIf="ctaPrivilege.value.edit" class="mx-3" (click)="handleGoTo(element, true)" [inlineSVG]="ASSET_ICON.IC_EDIT"></span>
                      </app-table-content>
                    </button>
                  </div>
                  <div *ngSwitchCase="'list_variants'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject">
                      <div style="gap: 10px">
                        <span class="product-list">{{ setVariantItem(element[tableColumn.key])?.name }}</span
                        ><br />
                        <span *ngIf="element[tableColumn.key]?.length > 1" class="desc">+{{ element[tableColumn.key]?.length - 1 }} Varian lainnya</span>
                      </div>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'list_sub_area'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject">
                      <div class="line-clamp">
                        <span
                          *ngIf="element[tableColumn.key]?.length > 2; else defaultItemText"
                          placement="bottom"
                          popoverClass="tooltip-info-product text-primary"
                          triggers="mouseenter:mouseleave"
                          [ngbPopover]="mapSubAreaObject(element[tableColumn.key])"
                          ><ng-template [ngTemplateOutlet]="defaultItemText"></ng-template
                        ></span>
                        <ng-template #defaultItemText>
                          <span class="text-capitalize">{{ mapSubAreaObject(element[tableColumn.key]) }}</span>
                        </ng-template>
                      </div>
                    </app-table-content>
                  </div>

                  <div *ngSwitchCase="'submitted_time'">
                    <app-table-content [count]="2" [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject" [type]="'text'">
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'dd-MM-yyyy') }}</div>
                      <div>{{ utilities.timeStampToDate(element['submitted_time'], 'HH:mm:ss') }}</div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchDefault>
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject">
                      <span>{{ element[tableColumn.key] ?? '-' }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>
        </div>

        <div class="d-flex justify-content-between py-4">
          <app-mai-material-bottom-table
            (changePage)="changePageEvent($event)"
            [baseDataTableComponent]="baseDatasourceProductExclusive"
            [isFinishLoadingSubject]="baseDatasourceProductExclusive.isFinishLoadingSubject"
            class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </ng-template>
    </ng-container>
  </app-card>
</ng-template>

<app-modal-detail-with-image #modalDetail [isLoading]="isLoading" [callbackDelete]="handleDeleteProduct" [detailModal]="detailProductExclusiveData"></app-modal-detail-with-image>

<app-modal #modalDelete [callbackSubmit]="submitForm" [modalConfig]="modalConfigDelete">
  <div>
    <p>Silahkan input alasan penghapusan produk eksklusif :</p>
    <div *ngFor="let item of listDeleteEnum.getValue()" class="form-check mb-4 d-flex align-items-center">
      <input (click)="toggleSelection($event)" [value]="item.code" class="form-check-input cursor-pointer" id="{{ item.code }}" type="checkbox" />
      <label class="form-check-label cursor-pointer ms-4 text-gray-800" for="{{ item.code }}">{{ item.name }}</label>
    </div>
    <ng-container *ngIf="isOther">
      <textarea [(ngModel)]="reason" class="form-control form-control-solid min-h-100px" cols="10" placeholder="Silahkan input alasan penolakan aktivasi" rows="3"></textarea>
    </ng-container>
  </div>
</app-modal>
